import { Navigate } from 'react-router-dom';
import { useAuth } from 'context/authContext';
import { ROLE_TYPES } from 'api/constants';

const ProtectedManagerRoute = ({ children }) => {
  const { auth, role } = useAuth();

  if (auth && role === ROLE_TYPES.slh_manager) return children;

  return <Navigate to="/" replace />;
};

export default ProtectedManagerRoute;
